import React, { useEffect } from 'react';
import { useForm } from "react-hook-form";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLoginMutation } from '../../features/auth/authApi';

const StudentLogin = () => {
    const navigate = useNavigate()
    const [userLoggedIn, { isLoading, isError, isSuccess, error, data: resData }] = useLoginMutation()
    const { register, handleSubmit, watch, reset, formState: { errors } } = useForm();
    const onSubmit = data => {
        userLoggedIn(data)
    }
    useEffect(() => {
        if (isSuccess) {
            if (resData.user.role === "student") {
                navigate(`/course`)
                toast.success('Welcome to the Course ' + resData.user.name)
            } else {
                toast.error('You are not a student')
                reset()
            }
        }
        if (isError) {
            if (error.status === 400) {
                toast.error(error.data)
            } else {
                toast.error("Something went wrong.")
            }

        }
    }, [isError, isSuccess])
    return (
        <section className="py-6 bg-primary h-screen grid place-items-center">
            <div className="mx-auto max-w-md px-5 lg:px-0">
                <div>
                    <Link to={'/admin'}>
                        <img className="h-12 mx-auto" src="/image/learningportal.svg" />
                    </Link>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
                        Sign in to Student Account
                    </h2>
                </div>
                <form onSubmit={handleSubmit(onSubmit)} className="mt-8 space-y-6" action="#" method="POST">
                    <input type="hidden" name="remember" value="true" />
                    <div className="rounded-md shadow-sm -space-y-px">
                        <div>
                            <label htmlFor="email-address" className="sr-only">Email address</label>
                            <input {...register("email", { required: true, })} id="email-address" name="email" type="email" autoComplete="email" required
                                className="login-input rounded-t-md" placeholder="Email address" />
                        </div>
                        <div>
                            <label htmlFor="password" className="sr-only">Password</label>
                            <input id="password" name="password" type="password" autoComplete="current-password" {...register("password", { required: true, })} required
                                className="login-input rounded-b-md" placeholder="Password" />
                        </div>
                    </div>

                    <div className="flex items-center justify-end">
                        <div className="text-sm">
                            <Link to='/register'>

                                <button type='button' className="font-medium text-violet-600 hover:text-violet-500">
                                    Create New Account
                                </button>
                            </Link>
                        </div>
                    </div>

                    <div>
                        <button disabled={isLoading} type="submit"
                            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
                            Sign in
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
};

export default StudentLogin;